/* eslint-disable max-len, padded-blocks, prefer-destructuring */
import api from '@/api';
import { loadModules } from 'esri-loader';
import ProjectTotalsCalculator from '@/mixins/projectTotalsCalculator';

export default {
  mixins: [ProjectTotalsCalculator],
  computed: {
    isSubmitProjectConceptEnabled() {
      if (!this.project || !this.project.rankingScore) return false;
      if (!this.projectConcept || !this.projectConcept.projectConceptProjectResourcePriorities || this.projectConcept.projectConceptProjectResourcePriorities.length === 0) return false;
      if (!this.projectConcept || this.projectConcept.estimatedCost == null) return false;
      if (!this.projectConcept || !this.projectConcept.statement || this.projectConcept.statement.length < 50) return false;
      return true;
    },
    getSubmitProjectConceptTitle() {
      if (!this.project || !this.project.rankingScore) return 'Invalid Ranking Score';
      if (!this.projectConcept || !this.projectConcept.projectConceptProjectResourcePriorities || this.projectConcept.projectConceptProjectResourcePriorities.length === 0) return 'Invalid Resource Priorities';
      if (!this.projectConcept || this.projectConcept.estimatedCost == null) return 'Invalid Estimated Cost';
      if (!this.projectConcept || !this.projectConcept.statement || this.projectConcept.statement.length < 50) return 'Invalid Project Concept Statement';
      return 'Submit Concept';
    },
    isSubmitProjectEnabled() {
      if (!this.project) {
        console.warn('Exit isSubmitProjectEnabled(): Invalid Project reference');
        this.submitProjectButtonTitle = 'Invalid Project reference';
        return false;
      }

      if (!this.projectBudget) {
        console.warn('Exit isSubmitProjectEnabled(): Invalid Project Budget reference');
        this.submitProjectButtonTitle = 'Invalid Project Budget reference';
        return false;
      }

      if (!this.projectBudget.projectBudgetYears || this.projectBudget.projectBudgetYears.length === 0) {
        console.warn('Exit isSubmitProjectEnabled(): Invalid Project Budget Years');
        this.submitProjectButtonTitle = 'Invalid Project Budget Years';
        return false;
      }

      const projectBudgetYears = this.projectBudget.projectBudgetYears.filter(
        (e) => e.projectBudgetLineItems && e.projectBudgetLineItems.length,
      );

      if (projectBudgetYears.length === 0) {
        console.warn('Exit isSubmitProjectEnabled(): Invalid Project Budget Line Item count');
        this.submitProjectButtonTitle = 'Invalid Project Budget Line Item count';
        return false;
      }

      if (!this.projectGoalSelections || !this.projectObjectiveSelections || !this.projectObjectiveAccomplishmentTargetSelections) {
        console.warn('Exit isSubmitProjectEnabled(): Invalid Project Target reference');
        this.submitProjectButtonTitle = 'Invalid Project Target reference';
        return false;
      }

      if (!this.projectPlanDetails) {
        console.warn('Exit isSubmitProjectEnabled(): Invalid Project PlanDetails reference');
        this.submitProjectButtonTitle = 'Invalid Project PlanDetails reference';
        return false;
      }

      if (!this.projectPractices) {
        console.warn('Exit isSubmitProjectEnabled(): Invalid Project Practices reference');
        this.submitProjectButtonTitle = 'Invalid Project Practices reference';
        return false;
      }

      if (this.projectGoalSelections.length === 0) {
        console.warn('Exit isSubmitProjectEnabled(): Invalid Project Goals');
        this.submitProjectButtonTitle = 'Invalid Project Goals';
        return false;
      }

      if (this.projectObjectiveSelections.length === 0) {
        console.warn('Exit isSubmitProjectEnabled(): Invalid Project Objectives');
        this.submitProjectButtonTitle = 'Invalid Project Objectives';
        return false;
      }

      if (this.projectObjectiveAccomplishmentTargetSelections.length === 0) {
        console.warn('Exit isSubmitProjectEnabled(): Invalid Project Accomplishment Targets');
        this.submitProjectButtonTitle = 'Invalid Project Accomplishment Targets';
        return false;
      }

      const bypassCategories = [
        'Conservation Ed Grant',
        'Conservation Ed Project',
        'Consulting',
        'Outreach & Education',
      ];

      if (!bypassCategories.includes(this.project.category)) {
        console.debug(`Project Action validation entered for category '${this.project.category}'`);
        if (this.projectPractices.length === 0) {
          console.warn('Exit isSubmitProjectEnabled(): Invalid Project Actions');
          this.submitProjectButtonTitle = 'Invalid Project Actions';
          return false;
        }
      } else {
        console.debug(`Project Action validation bypassed for category '${this.project.category}'`);
      }

      if (!bypassCategories.includes(this.project.category)) {
        console.debug(`Project Geometry validation entered for category '${this.project.category}'`);
        if (!this.projectGeometry) {
          console.warn('Exit isSubmitProjectEnabled(): Invalid Project Geometry');
          this.submitProjectButtonTitle = 'Invalid Project Geometry';
          return false;
        }
      } else {
        console.debug(`Project Geometry validation bypassed for category '${this.project.category}'`);
      }

      this.submitProjectButtonTitle = 'Submit Project';
      return true;
    },
    isApprovable() {
      if (!this.config || !this.submitStatus || !this.project || !this.project.approvalStatus) return false;
      switch (this.project.approvalStatus) {
        case this.submitStatus.Approved:
          return false;
        case this.submitStatus.ApprovedForPlanning:
          return false;
        case this.submitStatus.ConceptRejected:
          return false;
        case this.submitStatus.Draft:
          return false;
        case this.submitStatus.Rejected:
          return false;
        case this.submitStatus.SubmittedForPlanningApproval:
          return true;
        case this.submitStatus.SubmittedForProjectApproval:
          return false;
        default:
          return false;
      }
    },
    isRejectable() {
      if (!this.config || !this.submitStatus || !this.project || !this.project.approvalStatus) return false;
      switch (this.project.approvalStatus) {
        case this.submitStatus.Approved:
          return false;
        case this.submitStatus.ApprovedForPlanning:
          return false;
        case this.submitStatus.ConceptRejected:
          return false;
        case this.submitStatus.Draft:
          return false;
        case this.submitStatus.Rejected:
          return false;
        case this.submitStatus.SubmittedForPlanningApproval:
          return true;
        case this.submitStatus.SubmittedForProjectApproval:
          return false;
        default:
          return false;
      }
    },
    isSubmittable() {
      if (!this.config || !this.submitStatus || !this.project || !this.project.approvalStatus) return false;
      switch (this.project.approvalStatus) {
        case this.submitStatus.Approved:
          return false;
        case this.submitStatus.ApprovedForPlanning:
          return false;
        case this.submitStatus.ConceptRejected:
          return true;
        case this.submitStatus.Draft:
          return true;
        case this.submitStatus.Rejected:
          return false;
        case this.submitStatus.SubmittedForPlanningApproval:
          return false;
        case this.submitStatus.SubmittedForProjectApproval:
          return false;
        default:
          return false;
      }
    },
    isTabbable() {
      if (!this.config || !this.submitStatus || !this.project || !this.project.approvalStatus) return false;
      switch (this.project.approvalStatus) {
        case this.submitStatus.ConceptRejected:
          return false;
        case this.submitStatus.Draft:
          return false;
        case this.submitStatus.SubmittedForPlanningApproval:
          return false;
        default:
          return true;
      }
    },
    isProjectSubmittable() {
      if (!this.config || !this.submitStatus || !this.project || !this.project.approvalStatus) return false;
      switch (this.project.approvalStatus) {
        case this.submitStatus.Approved:
          return false;
        case this.submitStatus.ApprovedForPlanning:
          return true;
        case this.submitStatus.ConceptRejected:
          return false;
        case this.submitStatus.Draft:
          return false;
        case this.submitStatus.Rejected:
          return true;
        case this.submitStatus.SubmittedForPlanningApproval:
          return false;
        case this.submitStatus.SubmittedForProjectApproval:
          return false;
        default:
          return false;
      }
    },
    isProjectApprovable() {

      if (!this.config || !this.submitStatus || !this.project || !this.project.approvalStatus) return false;

      if (!this.fundingSourceSummaries) return false;
      if (!this.projectIncentivePayments) return false;
      if (!this.fundingSourceBudgets) return false;
      if (!this.fundingSourceEncumberedFunds) return false;
      if (!this.fundingSourceExpendedFunds) return false;
      if (!this.fundingSources) return false;

      switch (this.project.approvalStatus) {
        case this.submitStatus.Approved:
          return false;
        case this.submitStatus.ApprovedForPlanning:
          return false;
        case this.submitStatus.ConceptRejected:
          return false;
        case this.submitStatus.Draft:
          return false;
        case this.submitStatus.Rejected:
          return false;
        case this.submitStatus.SubmittedForPlanningApproval:
          return false;
        case this.submitStatus.SubmittedForProjectApproval:
          return true;
        default:
          return false;
      }
    },
    isProjectCancelable() {
      if (!this.config || !this.submitStatus || !this.project || !this.project.approvalStatus) return false;
      if (this.project.approvalStatus !== this.submitStatus.Approved) return false;
      return true;
    },
    isProjectCompletable() {
      if (!this.config || !this.submitStatus || !this.project || !this.project.approvalStatus) return false;
      if (this.project.approvalStatus !== this.submitStatus.Approved) return false;
      return true;
    },
    isProjectRejectable() {
      if (!this.config || !this.submitStatus || !this.project || !this.project.approvalStatus) return false;
      switch (this.project.approvalStatus) {
        case this.submitStatus.Approved:
          return false;
        case this.submitStatus.ApprovedForPlanning:
          return false;
        case this.submitStatus.ConceptRejected:
          return false;
        case this.submitStatus.Draft:
          return false;
        case this.submitStatus.Rejected:
          return false;
        case this.submitStatus.SubmittedForPlanningApproval:
          return false;
        case this.submitStatus.SubmittedForProjectApproval:
          return true;
        default:
          return false;
      }
    },
    isProjectOutcomesEnabled() {
      if (!this.config || !this.submitStatus || !this.project || !this.project.approvalStatus) return false;
      switch (this.project.approvalStatus) {
        case this.submitStatus.Approved:
          return true;
        case this.submitStatus.Cancelled:
          return true;
        case this.submitStatus.Completed:
          return true;
        default:
          return false;
      }
    },
  },
  methods: {
    async isProjectWorkOrderOpen() {
      this.formLoading = true;

      if (!this.projectWorkorders || this.projectWorkorders == null) {
        await this.$store.dispatch('Project/getProjectWorkorders', parseInt(this.$route.params.id, 10));
      }

      this.formLoading = false;
      return this.projectWorkorders.filter((e) => (e.status !== 'Completed') && (e.status !== 'Cancelled')).length > 0;
    },
    async isProjectWorkOrderBillUnpaid() {
      this.formLoading = true;

      if (!this.projectWorkorders || this.projectWorkorders == null) {
        await this.$store.dispatch('Project/getProjectWorkorders', parseInt(this.$route.params.id, 10));
      }

      if (!this.projectWorkorderBills || this.projectWorkorderBills == null) {
        await this.$store.dispatch(
          'Project/getProjectWorkorderBills',
          this.projectWorkorders.map((e) => e.id),
        );
      }

      this.formLoading = false;

      return this.projectWorkorderBills.filter(
        (e) => ((e.status !== 'Paid') && (e.status !== 'Void')),
      ).length > 0;
    },
    async isProjectIncentiveUnpaid() {
      return this.projectIncentivePayments.filter((e) => e.datePaid === null).length > 0;
    },
    isProjectWorkPlanned() {
      const unapprovedProjectBudgets = this.projectBudget.projectBudgetYears.filter((e) => e.status !== 'Approved');
      const unapprovedProjectBudgetLineItems = unapprovedProjectBudgets.map((e) => e.projectBudgetLineItems).flat();
      return unapprovedProjectBudgetLineItems.length > 0;
    },
    load() {
      (async () => {
        if (!this.projectBudget || !this.projectBudget.id) await this.$store.dispatch('Project/fetchProjectBudget', this.project.id);

        if (!this.fundingSources || this.fundingSources.length === 0) {
          this.$store.dispatch('Project/fetchFundingSources').then(() => {
            this.loadProjectBudgetValidationData();
          });
        } else {
          this.loadProjectBudgetValidationData();
        }

        // this.$store.dispatch('Project/getProjectAccomplishmentTargetsAsync', this.project.id);
        this.$store.dispatch('Project/fetchPlanDetails', this.project.id);
        this.$store.dispatch('Project/getProjectGoalSelectionsAsync', this.project.id);
        this.$store.dispatch('Project/getProjectIncentivePayments', this.project.id);
        this.$store.dispatch('Project/getProjectObjectiveAccomplishmentTargetSelectionsAsync', this.project.id);
        this.$store.dispatch('Project/getProjectObjectiveSelectionsAsync', this.project.id);
        this.$store.dispatch('Project/getProjectPractices', this.project.id);

        if (this.project.category !== 'Conservation Ed Project') {
          this.loadProjectGeometry();
        }
      })();
    },
    fundsForNewProjects() {
      return this.fundsPerFiscalYear
        .filter((e) => e.customfields.find((field) => field.fielD_NAME === 'Funding_Source__c')
          && e.customfields.find((field) => field.fielD_NAME === 'New_Projects_Budget__c'))
        .map((e) => ({
          id: e.customfields.find((field) => field.fielD_NAME === 'Funding_Source__c').fielD_VALUE,
          budget: e.customfields.find((field) => field.fielD_NAME === 'New_Projects_Budget__c').fielD_VALUE,
        })).sort((a, b) => a.id - b.id);
    },
    fundsForAnnualBudgets() {
      return this.fundsPerFiscalYear
        .filter((e) => e.customfields.find((field) => field.fielD_NAME === 'Funding_Source__c')
          && e.customfields.find((field) => field.fielD_NAME === 'Approved_Projects_Budget__c'))
        .map((e) => ({
          id: e.customfields.find((field) => field.fielD_NAME === 'Funding_Source__c').fielD_VALUE,
          budget: e.customfields.find((field) => field.fielD_NAME === 'Approved_Projects_Budget__c').fielD_VALUE,
        })).sort((a, b) => a.id - b.id);
    },
    loadProjectBudgetValidationData() {
      (async () => {
        await this.$store.dispatch('Project/getFundsPerFiscalYear', this.fiscalYear);
        this.fundingSourceBudgets = this.fundsForNewProjects();
        await this.$store.dispatch('Project/getFundingSourceEncumberedFunds', this.fiscalYear);
        await this.$store.dispatch('Project/getFundingSourceExpendedFunds', this.fiscalYear);
      })();
    },
    loadProjectGeometry() {
      loadModules(
        ['esri/geometry/geometryEngine', 'esri/identity/IdentityManager', 'esri/layers/FeatureLayer'],
        { css: true },
      ).then((
        [geometryEngine, IdentityManager, FeatureLayer],
      ) => {

        this.identityManager = IdentityManager;

        if (localStorage['acorn.identityManager']) {
          try {
            this.identityManager.initialize(localStorage['acorn.identityManager']);
          } catch (exception) {
            console.error('this.identityManager could not be initialized with localStorage[\'acorn.identityManager\']]');
          }
        }

        this.identityManager.on('credential-create', () => {
          try {
            localStorage['acorn.identityManager'] = JSON.stringify(this.identityManager.toJSON());
          } catch (exception) {
            console.error('localStorage[\'acorn.identityManager\'] could not be set with JSON.stringify(this.identityManager.toJSON())');
          }
        });

        const url = this.config.projectMap.layers.filter((e) => e.id === 'projectFeatureLayer')[0].url;
        const projectLayer = new FeatureLayer({ url });
        const query = projectLayer.createQuery();

        query.where = `insightlyid=${this.project.id}`;

        projectLayer.queryFeatures(query).then((results) => {
          if (results && results.features && results.features.length > 0) {
            const projectGeometry = geometryEngine.union(
              results.features.map((feature) => feature.geometry),
            );
            this.$store.dispatch('Project/setProjectGeometry', projectGeometry);
          } else {
            this.$store.dispatch('Project/setProjectGeometry', null);
          }
        });

      });
    },
    getProjectSummaryHref() {
      // force the last part of the path to the overview page
      return `${window.location.href.slice(0, window.location.href.lastIndexOf('/'))}/overview`;
    },
    onApproveProjectConceptClick() {
      this.project.approvalStatus = this.submitStatus.ApprovedForPlanning;
      this.onProjectClick();
      window.location.href = `mailto:${this.project.projectManager.emailAddress}?subject=Project Concept Approved&body=${this.project.projectName}: ${this.getProjectSummaryHref()}`;
    },
    onRejectProjectConceptClick() {
      this.project.approvalStatus = this.submitStatus.ConceptRejected;
      this.onProjectClick();
      window.location.href = `mailto:${this.project.projectManager.emailAddress}?subject=Project Concept Rejected&body=${this.project.projectName}: ${this.getProjectSummaryHref()}`;
    },
    onSubmitProjectConceptOkClick() {
      this.project.approvalStatus = this.submitStatus.SubmittedForPlanningApproval;
      this.onProjectClick();
    },
    async onApproveProjectClick() {
      this.isValidating = true;

      const validStartDate = this.validateProjectStartDate();
      if (!validStartDate) {
        this.$bvModal.show(this.invalidStartDateModal);
        return;
      }

      const fiscalYear = this.getFiscalYear(this.project.startDate);

      let fundingSourceIds = this.transformProjectBudgetToFundingSourceIds(this.projectBudget) || [];

      fundingSourceIds = [...new Set(fundingSourceIds)].sort((a, b) => a - b);

      const projectLineItems = this.transformProjectLineItems(this.projectBudget);

      const projectIncentivePayments = this.transformProjectIncentivePayments(this.projectIncentivePayments);

      if (projectIncentivePayments) {
        fundingSourceIds = fundingSourceIds.concat(projectIncentivePayments.map((e) => e.fundingSourceId));
      }

      await this.$store.dispatch('Project/getFundsPerFiscalYear', fiscalYear);
      const budgetedFunds = this.transformFundsPerFiscalYearToBudgetedFunds([...this.fundsPerFiscalYear], fundingSourceIds);

      await this.$store.dispatch('Project/getProjectSnapshots', fiscalYear);

      const lineItemEncumberedFunds = this.transformProjectSnapshotsToLineItemEncumberedFunds(this.project.id, fundingSourceIds, this.projectSnapshots, fiscalYear);

      const incentivePaymentEncumberedFunds = this.transformProjectSnapshotsToIncentivePaymentEncumberedFunds(this.project.id, fundingSourceIds, this.projectSnapshots);

      this.validateProjectBudget(
        fundingSourceIds,
        budgetedFunds,
        lineItemEncumberedFunds,
        incentivePaymentEncumberedFunds,
        projectLineItems,
        projectIncentivePayments,
      );

      this.isValidating = false;

      if (this.insufficientFunds) {
        this.$bvModal.show(this.insufficientFundsModal);
      } else {
        this.$bvModal.show(this.approveProjectModal);
      }
    },
    onApproveProjectOkClick() {
      this.project.approvalStatus = this.submitStatus.Approved;
      this.onProjectClick();
      window.location.href = `mailto:${this.project.projectManager.emailAddress}?subject=Project Plan Approved&body=${this.project.projectName}: ${this.getProjectSummaryHref()}`;
    },
    async onCancelProjectClick() {

      const isProjectWorkOrderOpen = await this.isProjectWorkOrderOpen();
      if (isProjectWorkOrderOpen) {
        this.cancelCompleteProjectErrorModalReason = 'OpenWorkOrder';
        this.cancelCompleteProjectErrorModalType = this.submitStatus.Cancelled;
        this.$bvModal.show(this.cancelCompleteProjectErrorModal);
        return;
      }

      const isProjectWorkOrderBillUnpaid = await this.isProjectWorkOrderBillUnpaid();
      if (isProjectWorkOrderBillUnpaid) {
        this.cancelCompleteProjectErrorModalReason = 'UnpaidBill';
        this.cancelCompleteProjectErrorModalType = this.submitStatus.Cancelled;
        this.$bvModal.show(this.cancelCompleteProjectErrorModal);
        return;
      }

      const isProjectIncentiveUnpaid = await this.isProjectIncentiveUnpaid();
      if (isProjectIncentiveUnpaid) {
        this.cancelCompleteProjectErrorModalReason = 'UnpaidIncentivePayment';
        this.cancelCompleteProjectErrorModalType = this.submitStatus.Cancelled;
        this.$bvModal.show(this.cancelCompleteProjectErrorModal);
        return;
      }

      this.$bvModal.show(this.cancelProjectModal);
    },
    onCancelProjectOkClick() {
      this.project.approvalStatus = this.submitStatus.Cancelled;
      this.onProjectClick();
    },
    async onCompleteProjectClick() {

      this.cancelCompleteProjectErrorModalType = this.submitStatus.Completed;

      const isProjectWorkOrderOpen = await this.isProjectWorkOrderOpen();
      if (isProjectWorkOrderOpen) {
        this.cancelCompleteProjectErrorModalReason = 'OpenWorkOrder';
        this.$bvModal.show(this.cancelCompleteProjectErrorModal);
        return;
      }

      const isProjectWorkOrderBillUnpaid = await this.isProjectWorkOrderBillUnpaid();
      if (isProjectWorkOrderBillUnpaid) {
        this.cancelCompleteProjectErrorModalReason = 'UnpaidBill';
        this.$bvModal.show(this.cancelCompleteProjectErrorModal);
        return;
      }

      const isProjectIncentiveUnpaid = await this.isProjectIncentiveUnpaid();
      if (isProjectIncentiveUnpaid) {
        this.cancelCompleteProjectErrorModalReason = 'UnpaidIncentivePayment';
        this.$bvModal.show(this.cancelCompleteProjectErrorModal);
        return;
      }

      const isProjectWorkPlanned = this.isProjectWorkPlanned();
      if (isProjectWorkPlanned) {
        this.$bvModal.show(this.projectWorkOrderPlannedModal);
        return;
      }

      this.$bvModal.show(this.completeProjectModal);

    },
    onProjectWorkOrderPlannedModalOkClick() {
      this.$bvModal.show(this.completeProjectModal);
    },
    onCompleteProjectOkClick() {
      this.project.approvalStatus = this.submitStatus.Completed;
      this.onProjectClick();
    },
    onRejectProjectOkClick() {
      this.project.approvalStatus = this.submitStatus.Rejected;
      this.onProjectClick();
      window.location.href = `mailto:${this.project.projectManager.emailAddress}?subject=Project Plan Rejected&body=${this.project.projectName}: ${this.getProjectSummaryHref()}`;
    },
    onSubmitProjectClick() {
      this.$store.dispatch('Project/setPlanDetailsLoading', true);
      this.$store.dispatch('Project/forceFetchPlanDetails', this.project.id).then(() => {
        this.$store.dispatch('Project/setPlanDetailsLoading', false);
        if (!this.validatePlanDetails(this.projectPlanDetails)) {
          this.$bvModal.show(this.invalidPlanDetailsModal);
        } else {
          this.$bvModal.show(this.submitProjectModal);
        }
      });
    },
    onSubmitProjectOkClick() {
      this.project.approvalStatus = this.submitStatus.SubmittedForProjectApproval;
      this.onProjectClick();
    },
    onProjectClick() {
      (async () => {
        this.formLoading = true;

        await this.$store.dispatch('Project/setProjectApprovalStatus', { id: this.project.id, status: this.project.approvalStatus });

        if (
          this.project.approvalStatus === this.config.projectOverviewPage.submitStatus.Completed
          || this.project.approvalStatus === this.config.projectOverviewPage.submitStatus.Cancelled
        ) {
          await this.$store.dispatch('Project/setProjectStatus', { id: this.project.id, status: this.project.approvalStatus });
        }

        this.formLoading = false;

        // Use props/watchers to communicate status change to child components
        this.$store.state.Project.projectStatus = this.project.approvalStatus;
      })();
    },
    transformFundsPerFiscalYearToBudgetedFunds(fundsPerFiscalYear, fundingSourceIds) {
      let fundsPerFiscalYearObjects = fundsPerFiscalYear.map((e) => {

        const fundPerFiscalYear = {
          fundingSourceId: null,
          fiscalYear: null,
          id: e.recorD_ID,
          name: e.recorD_NAME,
          approvedProjectsBudget: 0,
          newProjectsBudget: 0,
        };

        let fundingSourceFieldName = 'Funding_Source__c';
        let fundingSourceField = e.customfields.find((customField) => customField.fielD_NAME === fundingSourceFieldName);
        if (fundingSourceField) {
          fundPerFiscalYear.fundingSourceId = fundingSourceField.fielD_VALUE;
        }

        fundingSourceFieldName = 'Fiscal_Year__c';
        fundingSourceField = e.customfields.find((customField) => customField.fielD_NAME === fundingSourceFieldName);
        if (fundingSourceField) {
          fundPerFiscalYear.fiscalYear = fundingSourceField.fielD_VALUE;
        }

        fundingSourceFieldName = 'Approved_Projects_Budget__c';
        fundingSourceField = e.customfields.find((customField) => customField.fielD_NAME === fundingSourceFieldName);
        if (fundingSourceField) {
          fundPerFiscalYear.approvedProjectsBudget = fundingSourceField.fielD_VALUE;
        }

        fundingSourceFieldName = 'New_Projects_Budget__c';
        fundingSourceField = e.customfields.find((customField) => customField.fielD_NAME === fundingSourceFieldName);
        if (fundingSourceField) {
          fundPerFiscalYear.newProjectsBudget = fundingSourceField.fielD_VALUE;
        }

        return fundPerFiscalYear;
      });

      fundsPerFiscalYearObjects = fundsPerFiscalYearObjects.filter((e) => fundingSourceIds.includes(e.fundingSourceId));

      const fundingSourceObjectIds = [...new Set(fundsPerFiscalYearObjects.map((e) => e.fundingSourceId))];
      const fundingSourceObjects = fundingSourceObjectIds.map((e) => ({ fundingSourceId: e, approvedProjectsBudget: 0, newProjectsBudget: 0 }));

      fundingSourceObjects.forEach((e) => {
        const fundingSourceFundsPerFiscalYear = fundsPerFiscalYearObjects.filter((fundPerFiscalYear) => fundPerFiscalYear.fundingSourceId === e.fundingSourceId);
        if (fundingSourceFundsPerFiscalYear.length > 0) {
          e.approvedProjectsBudget = fundingSourceFundsPerFiscalYear.map((fsfpfy) => fsfpfy.approvedProjectsBudget).reduce((a, b) => a + b);
          e.newProjectsBudget = fundingSourceFundsPerFiscalYear.map((fsfpfy) => fsfpfy.newProjectsBudget).reduce((a, b) => a + b);
        }
      });

      return fundingSourceObjects;
    },
    transformProjectBudgetToFundingSourceIds(projectBudget) {
      let fundingSourceIds = [];

      if (projectBudget.projectBudgetYears) {
        projectBudget.projectBudgetYears.forEach((projectBudgetYear) => {
          if (projectBudgetYear.projectBudgetLineItems) {
            const projectBudgetYearFundingSourceIds = projectBudgetYear.projectBudgetLineItems.map((e) => e.fundingSourceId);
            fundingSourceIds = fundingSourceIds.concat(projectBudgetYearFundingSourceIds);
          }
        });
      }

      fundingSourceIds = [...new Set(fundingSourceIds)];
      return fundingSourceIds;
    },
    transformProjectIncentivePayments(projectIncentivePayments) {
      const incentivePaymentObjectIds = [...new Set(projectIncentivePayments.map((e) => e.fundingSourceId))];

      const incentivePaymentObjects = incentivePaymentObjectIds.map((e) => {

        const incentivePaymentObject = {
          fundingSourceId: e,
          totalIncentivePayments: 0,
        };

        const fundingSourceIncentivePayments = projectIncentivePayments.filter(
          (incentivePayment) => incentivePayment.fundingSourceId === e,
        ).map(
          (incentivePayment) => incentivePayment.amountPaid,
        );

        if (fundingSourceIncentivePayments) {
          incentivePaymentObject.totalIncentivePayments = fundingSourceIncentivePayments.reduce((a, b) => a + b);
        }

        return incentivePaymentObject;
      });

      return incentivePaymentObjects;
    },
    transformProjectLineItems(projectBudget) {
      const projectBudgetLineItems = [];

      if (projectBudget.projectBudgetYears) {
        projectBudget.projectBudgetYears.forEach((projectBudgetYear) => {
          if (projectBudgetYear.projectBudgetLineItems) {
            projectBudgetYear.projectBudgetLineItems.forEach((projectBudgetLineItem) => {

              const quantity = projectBudgetLineItem.quantity;
              const unitCost = projectBudgetLineItem.unitCost;
              const costShare = (projectBudgetLineItem.costShare * 0.01);
              const contingencyPercent = 1 + (projectBudgetLineItem.contingencyPercent * 0.01);

              /* eslint-disable-next-line */
              const itemCost = Math.round(((quantity * (unitCost * 100)) * costShare) * contingencyPercent) / Math.pow(10, 2);

              const lineItem = {
                fundingSourceId: projectBudgetLineItem.fundingSourceId,
                quantity,
                unitCost,
                costShare,
                contingencyPercent,
                itemCost,
              };
              projectBudgetLineItems.push(lineItem);
            });
          }
        });
      }

      const lineItemIds = [...new Set(projectBudgetLineItems.map((e) => e.fundingSourceId))];
      const lineItemObjects = lineItemIds.map((e) => {
        const lineItemObject = {
          fundingSourceId: e,
          totalLineItems: 0,
        };
        const lineItems = projectBudgetLineItems.filter((projectBudgetLineItem) => projectBudgetLineItem.fundingSourceId === e) || null;
        if (lineItems) {
          lineItemObject.totalLineItems = lineItems.map((lineItem) => lineItem.itemCost).reduce((a, b) => a + b);
        }
        return lineItemObject;
      });

      return lineItemObjects;
    },
    transformProjectSnapshotsToIncentivePaymentEncumberedFunds(projectId, fundingSourceIds, projectSnapshots) {
      const fundingSourceIncentivePaymentSnapshots = [];

      projectSnapshots.filter((projectSnapshot) => projectSnapshot.projectId !== projectId).forEach((projectSnapshot) => {
        if (projectSnapshot.projectIncentivePaymentSnapshots) {
          projectSnapshot.projectIncentivePaymentSnapshots.filter(
            (projectIncentivePaymentSnapshot) => fundingSourceIds.includes(projectIncentivePaymentSnapshot.fundingSourceId),
          ).forEach(
            (fundingSourceIncentivePaymentSnapshot) => {
              fundingSourceIncentivePaymentSnapshots.push({ ...fundingSourceIncentivePaymentSnapshot });
            },
          );
        }
      });

      const incentivePaymentEncumberedFundsIds = [...new Set(fundingSourceIncentivePaymentSnapshots.map((e) => e.fundingSourceId))];

      const incentivePaymentEncumberedFundsObjects = incentivePaymentEncumberedFundsIds.map((e) => {
        const incentivePaymentEncumberedFundsObject = {
          fundingSourceId: e,
          totalRequested: 0,
        };
        incentivePaymentEncumberedFundsObject.totalRequested = fundingSourceIncentivePaymentSnapshots.filter(
          (snapshot) => snapshot.fundingSourceId === e,
        ).map(
          (snapshot) => snapshot.amountPaid,
        ).reduce(
          (a, b) => a + b,
        );
        return incentivePaymentEncumberedFundsObject;
      });

      return incentivePaymentEncumberedFundsObjects;
    },
    transformProjectSnapshotsToLineItemEncumberedFunds(projectId, fundingSourceIds, projectSnapshots, fiscalYear) {
      const fundingSourceLineItems = [];

      projectSnapshots.filter((projectSnapshot) => projectSnapshot.projectId !== projectId).forEach((projectSnapshot) => {
        if (projectSnapshot.projectBudgetYearSnapshots) {
          projectSnapshot.projectBudgetYearSnapshots.filter((projectBudgetYearSnapshot) => projectBudgetYearSnapshot.year === fiscalYear)
            .forEach((projectBudgetYearSnapshot) => {
              if (projectBudgetYearSnapshot.projectBudgetLineItemSnapshots) {
                projectBudgetYearSnapshot.projectBudgetLineItemSnapshots.filter(
                  (projectBudgetLineItemSnapshot) => fundingSourceIds.includes(projectBudgetLineItemSnapshot.fundingSourceId),
                ).forEach(
                  (projectBudgetLineItemSnapshot) => {
                    const fundingSourceLineItem = {
                      projectId: projectSnapshot.projectId,
                      fundingSourceId: projectBudgetLineItemSnapshot.fundingSourceId,
                      quantity: projectBudgetLineItemSnapshot.quantity,
                      unitCost: projectBudgetLineItemSnapshot.unitCost,
                      costShare: projectBudgetLineItemSnapshot.costShare,
                      contingencyPercent: projectBudgetLineItemSnapshot.contingencyPercent,
                      itemCost: 0,
                    };

                    const itemCost = fundingSourceLineItem.quantity * (fundingSourceLineItem.unitCost * 100);

                    const costShare = fundingSourceLineItem.costShare * 0.01;

                    const contingency = 1 + (fundingSourceLineItem.contingencyPercent * 0.01);

                    /* eslint-disable-next-line */
                    fundingSourceLineItem.itemCost = Math.round((itemCost * costShare) * contingency) / Math.pow(10, 2);

                    fundingSourceLineItems.push(fundingSourceLineItem);
                  },
                );
              }
            });
        }
      });

      const encumberedFundsIds = [...new Set(fundingSourceLineItems.map((e) => e.fundingSourceId))];

      const encumberedFundsObjects = encumberedFundsIds.map((e) => {

        const encumberedFundsObject = {
          fundingSourceId: e,
          totalRequested: 0,
        };

        const lineItems = fundingSourceLineItems.filter((lineItem) => lineItem.fundingSourceId === e);

        if (lineItems) {
          encumberedFundsObject.totalRequested = lineItems.map((lineItem) => lineItem.itemCost).reduce((a, b) => a + b);
        }

        return encumberedFundsObject;
      });

      return encumberedFundsObjects;
    },
    validatePlanDetails(planDetails) {
      const result = [
        planDetails.locationWatershedContext,
        planDetails.prioritizationContext,
        planDetails.projectRationale,
        planDetails.projectActions,
        planDetails.projectEvaluation,
        planDetails.scheduleOfActivities,
      ].map((e) => this.validatePlanDetailsNarrative(e)).filter((e) => e === false).length;
      return result === 0;
    },
    validatePlanDetailsNarrative(narrative) {
      if (narrative == null) return false;
      const div = document.createElement('div');
      div.innerHTML = narrative;
      let valid = true;
      if (!(div.textContent.length >= 5)) {
        valid = false;
      }
      return valid;
    },
    async validateAnnualBudgetIncrease(fiscalYear, annualBudgetIncrease) {
      const fundingSourceId = annualBudgetIncrease.fundingSourceId;

      const fundingSourceName = this.fundingSources.find(
        (e) => e.recorD_ID === Number(fundingSourceId),
      ).recorD_NAME;

      const fundingSourceBudget = await this.getFundingSourceBudgetModel(
        fundingSourceId,
        fiscalYear,
      );

      const fundingSourceEncumberedFundsTotal = await this.getFundingSourceEncumberedFundsTotal(
        fundingSourceId,
        fiscalYear,
      );

      this.projectBudgetValidationResults = [];

      const projectBudgetValidationResult = {
        id: fundingSourceId,
        name: fundingSourceName,
        totalApprovedBudget: fundingSourceBudget.approvedProjectsBudget,
        totalEncumberedFunds: fundingSourceEncumberedFundsTotal,
        totalApprovedBudgetRemaining: fundingSourceBudget.approvedProjectsBudget - fundingSourceEncumberedFundsTotal,
        totalAnnualBudgetIncrease: annualBudgetIncrease.adjustmentToAnnualBudget,
        totalProjectBudgetIncrease: annualBudgetIncrease.adjustmentToProjectBudget,
        totalAnnualBudgetDifference: fundingSourceBudget.approvedProjectsBudget - fundingSourceEncumberedFundsTotal - annualBudgetIncrease.adjustmentToProjectBudget,
      };

      this.projectBudgetValidationResults.push(projectBudgetValidationResult);
      this.projectBudgetValidationResults = this.projectBudgetValidationResults.sort((a, b) => a.name.localeCompare(b.name));
    },
    async getFundingSourceBudgetModel(fundingSourceId, fiscalYear) {
      const fundingSourceBudget = {
        fundingSourceId,
        fiscalYear,
        approvedProjectsBudget: 0,
        newProjectsBudget: 0,
      };

      await this.$store.dispatch('Project/getFundsPerFiscalYear', fiscalYear);
      const fundsPerFiscalYear = this.fundsPerFiscalYear.map((e) => ({ ...e }));
      const fundingSourceFundsPerFiscalYear = fundsPerFiscalYear.map((e) => {

        const fundingSourceFundPerFiscalYear = {
          id: e.recorD_ID,
          name: e.recorD_NAME,
          fundingSourceId: null,
          fiscalYear: null,
          approvedProjectsBudget: 0,
          newProjectsBudget: 0,
        };

        let customfield = e.customfields.find((cf) => cf.fielD_NAME === 'Funding_Source__c');
        if (customfield && customfield.fielD_VALUE) {
          fundingSourceFundPerFiscalYear.fundingSourceId = customfield.fielD_VALUE;
        }

        customfield = e.customfields.find((cf) => cf.fielD_NAME === 'Fiscal_Year__c');
        if (customfield && customfield.fielD_VALUE) {
          fundingSourceFundPerFiscalYear.fiscalYear = customfield.fielD_VALUE;
        }

        customfield = e.customfields.find((cf) => cf.fielD_NAME === 'Approved_Projects_Budget__c');
        if (customfield && customfield.fielD_VALUE) {
          fundingSourceFundPerFiscalYear.approvedProjectsBudget = customfield.fielD_VALUE;
        }

        customfield = e.customfields.find((cf) => cf.fielD_NAME === 'New_Projects_Budget__c');
        if (customfield) {
          fundingSourceFundPerFiscalYear.newProjectsBudget = customfield.fielD_VALUE;
        }

        return fundingSourceFundPerFiscalYear;

      }).filter((e) => e.fundingSourceId === fundingSourceId);

      if (fundingSourceFundsPerFiscalYear.length > 0) {
        fundingSourceBudget.approvedProjectsBudget = fundingSourceFundsPerFiscalYear.map((e) => e.approvedProjectsBudget).reduce((a, b) => a + b);
        fundingSourceBudget.newProjectsBudget = fundingSourceFundsPerFiscalYear.map((e) => e.newProjectsBudget).reduce((a, b) => a + b);
      }

      return fundingSourceBudget;
    },
    async getFundingSourceEncumberedFundsTotal(fundingSourceId, fiscalYear) {
      const response = await api.get(`/fundingSourceEncumberedFunds/fundingSourceId/${fundingSourceId}/fiscalYear/${fiscalYear}`);
      const fundingSourceEncumberedFunds = response.data;

      let fundingSourceEncumberedFundsTotal = 0;
      if (fundingSourceEncumberedFunds !== null && fundingSourceEncumberedFunds.length > 0) {
        fundingSourceEncumberedFundsTotal = fundingSourceEncumberedFunds.map((e) => e.budget).reduce((a, b) => a + b);
      }

      return fundingSourceEncumberedFundsTotal;
    },
    validateProjectStartDate() {
      let isValid = true;
      const projectStartDate = this.project.startDate ?? null;
      if (projectStartDate === null) {
        isValid = false;
      }
      return isValid;
    },
    validateProjectBudget(
      fundingSourceIds,
      budgetedFunds,
      lineItemEncumberedFunds,
      incentivePaymentEncumberedFunds,
      projectLineItems,
      projectIncentivePayments,
    ) {
      this.projectBudgetValidationResults = [];

      this.projectBudgetValidationResults = fundingSourceIds.map((e) => {

        const validationResult = {
          fundingSourceId: e,
          fundingSourceName: '(N/A)',
          totalBudgeted: 0,
          totalEncumberedLineItems: 0,
          totalEncumberedIncentivePayments: 0,
          totalEncumbered: 0,
          totalAvailable: 0,
          totalRequestedLineItems: 0,
          totalRequestedIncentivePayments: 0,
          totalRequested: 0,
          totalDifference: 0,
        };

        const projectFundingSource = (this.fundingSources.find((fundingSource) => fundingSource.recorD_ID === e)) || null;
        if (projectFundingSource) {
          validationResult.fundingSourceName = projectFundingSource.recorD_NAME;
        }

        const totalBudgeted = budgetedFunds.find((budgetedFund) => budgetedFund.fundingSourceId === e) || null;
        if (totalBudgeted) {
          validationResult.totalBudgeted = totalBudgeted.newProjectsBudget;
        }

        const totalEncumberedLineItems = lineItemEncumberedFunds.find((lineItemEncumberedFund) => lineItemEncumberedFund.fundingSourceId === e) || null;
        if (totalEncumberedLineItems) {
          validationResult.totalEncumberedLineItems = totalEncumberedLineItems.totalRequested;
        }

        const totalEncumberedIncentivePayments = incentivePaymentEncumberedFunds.find((incentivePaymentEncumberedFund) => incentivePaymentEncumberedFund.fundingSourceId === e) || null;
        if (totalEncumberedIncentivePayments) {
          validationResult.totalEncumberedIncentivePayments = totalEncumberedIncentivePayments.totalRequested;
        }

        validationResult.totalAvailable = validationResult.totalBudgeted - validationResult.totalEncumberedLineItems - validationResult.totalEncumberedIncentivePayments;

        const totalRequestedLineItems = projectLineItems.find((projectIncentivePayment) => projectIncentivePayment.fundingSourceId === e) || null;
        if (totalRequestedLineItems) {
          validationResult.totalRequestedLineItems = totalRequestedLineItems.totalLineItems;
        }

        const totalRequestedIncentivePayments = projectIncentivePayments.find((projectIncentivePayment) => projectIncentivePayment.fundingSourceId === e) || null;
        if (totalRequestedIncentivePayments) {
          validationResult.totalRequestedIncentivePayments = totalRequestedIncentivePayments.totalIncentivePayments;
        }

        validationResult.totalEncumbered = (validationResult.totalEncumberedLineItems + validationResult.totalEncumberedIncentivePayments);
        validationResult.totalRequested = (validationResult.totalRequestedLineItems + validationResult.totalRequestedIncentivePayments);
        validationResult.totalDifference = (validationResult.totalAvailable - validationResult.totalRequested);

        return validationResult;
      });

      this.projectBudgetValidationResults = this.projectBudgetValidationResults.sort((a, b) => a.fundingSourceName.localeCompare(b.fundingSourceName));
    },
  },
};
